import {CSSProperties, FC} from 'react';


export interface IIconVideoPlay2Props {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconVideoPlay2: FC<IIconVideoPlay2Props> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 23"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M.073 7.178c0-.944.132-3.065.661-3.997.661-1.166 1.157-1.666 2.48-2.499C4.27.016 12.467-.039 16.433.016c2.755.056 8.462.2 9.256.333.991.167 2.479.667 3.47 2.665.794 1.599.882 4.664.827 5.996v6.995c0 1.055-.232 3.464-1.157 4.663-1.157 1.5-1.818 1.832-3.305 1.999-1.19.133-6.776.277-9.42.333-3.141-.055-9.686-.2-10.743-.333l-.077-.01c-1.302-.163-2.752-.346-3.725-1.489C.57 20.002.238 18.17.073 16.005c-.132-1.732-.055-6.606 0-8.827Zm11.073 5.496v-5.11c0-.72.496-1.772 2.149-.886 1.322.709 4.627 2.516 6.115 3.331.66.389 1.652 1.366.33 2.165-1.322.8-4.627 2.554-6.115 3.331-.992.667-2.876 1.033-2.479-2.831Z" clipRule="evenodd" />
        </svg>
    );
};
